import React, { useEffect } from 'react';
import './App.css';
import LoginPage from './Pages/Login/LoginPage';
import WorkSpaceLayOut from './Layout/Work-space-layout/WorkSpaceLayOut';
import Cookies from 'universal-cookie';
import { onMessageListener, requestPermission } from './firebase';
import { User } from './Model/dbo/User';




function checktoken() {
  const cook = new Cookies();
  var user = cook.get('user') as User;
  if (user) 
    return true;

    return false;

}

function App() {

  useEffect(() => {
    requestPermission();

    onMessageListener().then(payload => {
      console.log('Message received: ', payload);
      // نمایش نوتیفیکیشن به کاربر
      alert(`Notification: ${payload.notification.title}`);
    }).catch(err => console.log('Failed to receive message: ', err));
  }, []);


  if (checktoken()) {
    return (
      <WorkSpaceLayOut />
       
    )
  }
  else {
    return (
      <>
         <LoginPage />
      </>
    );

  }
}

export default App;
